const WorkroomService = class WorkroomService {
  constructor () {
    'ngInject'
  }
}
export default WorkroomService
